import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { isDefined } from '@hsp/utilities';

import { IDonor } from 'types/api';

const columnHelper = createColumnHelper<IDonor>();

export const previewColumns: ColumnDef<IDonor, never>[] = [
  columnHelper.accessor('firstName', {
    cell: (props) => props.getValue(),
    header: 'First',
  }),
  columnHelper.accessor('middle', {
    cell: (props) => props.getValue(),
    header: 'Mid',
  }),
  columnHelper.accessor('lastName', {
    cell: (props) => props.getValue(),
    header: 'Last',
  }),
  columnHelper.accessor('address.street', {
    cell: (props) => props.getValue(),
    header: 'Address1',
  }),
  columnHelper.accessor('address.city', {
    cell: (props) => props.getValue(),
    header: 'City',
  }),
  columnHelper.accessor('address.state', {
    cell: (props) => props.getValue(),
    header: 'State',
  }),
  columnHelper.accessor(
    ({ address: { zip_Code: zipCode, zip_Code_4: zipCode4 } }) =>
      `${zipCode}${isDefined(zipCode4) ? `-${zipCode4}` : ''}`,
    {
      cell: (props) => props.getValue(),
      header: 'Zip',
    }
  ),
];
